import React, { Component } from 'react';
import { Switch } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions } from "store";
import { arrayIsEqual, tableColumn } from "utils";
import { TableList, ActionButton, DateTimeText } from 'components/common';
import UserValue from "../UserValue";


class UserList extends Component {
  state = {
    updateItemId: null,
    columnList: ['id', 'email', 'first_name', 'last_name', 'date_joined', 'role', 'is_active', 'actions'],
    columnByName: {
      id: tableColumn('ID', 'id', {
        sorter: true,
        width: 59,
      }),
      email: tableColumn('E-mail', 'email', {
        render: (val, item) => <UserValue detail={item} asLink={true}/>,
        sorter: true,
      }),
      first_name: tableColumn('Имя', 'first_name', {
        sorter: true,
        width: 150,
      }),
      last_name: tableColumn('Фамилия', 'last_name', {
        sorter: true,
        width: 150,
      }),
      date_joined: tableColumn('Дата регистрации', 'date_joined', {
        render: (val, item) => <DateTimeText date={val}/>,
        sorter: true,
        width: 150,
      }),
      role: tableColumn('Роль', 'role', {
        width: 150,
      }),
      is_active: tableColumn('Активен', 'is_active', {
        sorter: true,
        width: 150,
        render: (val, item) =>
          <div>
            <Switch
              style={{ marginTop: '5px', minWidth: '62px' }}
              checkedChildren="вкл" unCheckedChildren="выкл"
              checked={item.is_active}
              loading={this.props.user.updateStatus.isLoading && this.state.updateItemId === item.id}
              onClick={() => this.userOnOff(item)}
            />
          </div>,
      }),
      actions: tableColumn('', 'actions', {
        align: 'right',
        render: (val, item) => (
          <ActionButton
            actions={[{
              title: 'Редактировать', key: 'edit', icon: 'edit', action: () => this.showEditForm(item),
            }, {
              title: 'Удалить', key: 'delete', icon: 'delete', action: () => this.delete(item),
              confirm: {
                title: 'Уверены, что хотите удалить?',
                okText: 'Удалить',
                cancelText: 'Отмена'
              }
            }]}
          />
        ),
      }),
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { columnList } = nextProps;
    if (columnList && !arrayIsEqual(prevState.columnList, columnList)) {
      return {
        columnList: columnList,
      }
    }
    return null;
  }

  load = ({ query, activeFilter }) => {
    const { user } = this.props;
    if (activeFilter === undefined) {
      activeFilter = user.filter.activeFilter
    }
    this.props.actions.userListLoad({ query, activeFilter, locationChange: true });
  };

  showEditForm = (item) => {
    this.props.actions.userShowEditForm({ show: true, object: item })
  };

  delete = (item) => {
    this.props.actions.userDelete({ id: item.id })
  };

  userOnOff = (item) => {
    const data = { id: item.id, is_active: !item.is_active, preventLoadDetail: true };
    this.setState({
      updateItemId: item.id,
    });
    this.props.actions.userUpdate(data);
  };

  render() {
    const { user, defaultFilter, activeFilter, topActions, history } = this.props;
    const { columnList, columnByName } = this.state;

    return (
      <TableList
        history={history}
        data={user}
        defaultFilter={defaultFilter}
        activeFilter={activeFilter}
        columnList={columnList}
        columnByName={columnByName}
        onLoadData={this.load}
        topActions={topActions}
        showSearch={true}
        onRow={(item, rowIndex) => {
          return {
            onDoubleClick: event => {
              this.props.history.push(`/user/${item.id}`);
            },
          };
        }}

        filterFields={{
          list: [
            'is_active',
          ],
          byName: {
            'is_active': {
              label: 'Активно',
              type: 'bool',
            },
          }
        }}
      />
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({},
      actions.user,
    ), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
